/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// -----------------------------
// 2024.4.13 Add start : Google analytics tag (Added to cart)
//  ※メタフィールド情報は『product-item.liquidのdata属性から取得します』
// -----------------------------
document.addEventListener('variant:added', function(event) {
  const variant = event.detail.variant;
  let productBrand = null,
    productType = null;

  (async () => {
    const fetchResponse = await fetch("".concat(variant.url, "&view=get-metafield"), {
      credentials: 'same-origin',
      method: 'GET'
    });
    const result = await fetchResponse.text();

    if(result && result !== ''){
      const contentElem = document.createElement('div');
      contentElem.innerHTML = result;
      const gridHtml = contentElem.querySelector('.get-product-metafield-item product-item');
      if(gridHtml){
        productBrand = gridHtml.getAttribute('data-product_brand') !== "" ? gridHtml.getAttribute('data-product_brand') : null,
        productType =  gridHtml.getAttribute('data-product_type') !== "" ? gridHtml.getAttribute('data-product_type') : null;
      }
    }

    const itemHandle = variant.url.split('/').pop().split('?').shift();
    const addProductsItem = {
      add: {
        products: [{
          'name': variant.product_title,
          'id': itemHandle,
          'price': variant.price,
          'brand': productBrand,
          'category': productType,
          'variant': variant.variant_title,
          'quantity': variant.quantity,
        }],
      },
    };

    dataLayer.push({
      event: "addToCart",
      ecommerce: addProductsItem,
    });
    console.log({
      event: "addToCart",
      ecommerce: addProductsItem,
    });

    const addedProductInfoForDatalayer = {
      event: "additional_cart",
      added_item_id: itemHandle
    }
    dataLayer.push(addedProductInfoForDatalayer);
  })();
});
// -----------------------------
// 2024.4.13 Add end : Google analytics tag (Added to cart)
// -----------------------------

// -----------------------------
// 2024.4.13 Add start : Lineitem remove button function
// -----------------------------
const removeLineItem = (itemIndex,itemHandle) => {
  const formData = {
    line: parseInt(itemIndex),
    quantity: 0,
  };
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      dataType: "json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((response) => {
      const addedProductInfoForDatalayer = {
        event: "additional_cart",
        deleted_item_id: itemHandle
      }
      dataLayer.push(addedProductInfoForDatalayer);
    })
    .catch((error) => {
      console.error("Error:", error);
    })
    .finally(() => {
      location.href="/cart";
    });
}
// -----------------------------
// 2024.4.13 Add end : Lineitem remove button function
// -----------------------------

// -----------------------------
// 2024.5.3 Add Start : Clear cart agreement status when move to another page.
// -----------------------------
document.addEventListener("DOMContentLoaded", () => {
  if(location.pathname !== "/cart"){
    localStorage.removeItem("reservation_agreement");
  }
});
// -----------------------------
// 2024.5.3 Add End : Clear cart agreement status when move to another page.
// -----------------------------

// 2024.11.17 Add Start : 規約ページ 別タブ表示の場合、ページを閉じるボタン
document.addEventListener("DOMContentLoaded", () => {
  const urlParams = new URLSearchParams(window.location.search);
  const fromExternal = urlParams.get("from") === "form";
  const policyBody = document.querySelector(".shopify-policy__body");

  if(fromExternal && policyBody){
    const closeBtn = document.createElement("button");
    closeBtn.id = "closeBtn";
    closeBtn.classList.add("button" , "button--primary");
    closeBtn.style.margin = "1.5rem auto 0";
    closeBtn.style.display = "block";
    closeBtn.textContent = "< ブラウザを閉じる";
    policyBody.appendChild(closeBtn);
    closeBtn.addEventListener("click", () => {
      window.close();
      if (!window.closed) {
        closeBtn.textContent = 'ブラウザを閉じていただき、よろしければ規約に同意してください。';
      }
    });
  }
});

// -----------------------------
// 2024.12.20 Add Start :Header predictive search
// -----------------------------
// あいまい検索処理
const charToFuzzy = (str) => {
  let returnStr = "";
  // 1. ひらがなをカタカナに変換 (あいまい検索用)
  returnStr = str.replace(/[\u3041-\u3096]/g, function(match) {
    var char = match.charCodeAt(0) + 0x60;
    return String.fromCharCode(char);
  });

  // 2. 記号を無視
  const ignoreChars = /[\s!"#ー・･$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]/g;
  returnStr = returnStr.replace(ignoreChars, "");

  // 3. 全角数字を半角数字に変換
  returnStr = returnStr.replace(/[０-９]/g, function(s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
  
  // 4. カナの小文字を大文字に変換
  returnStr = returnStr.replace(/ァ|ィ|ゥ|ェ|ォ|ッ|ャ|ュ|ョ|ヮ|ヵ|ヶ/g,
    function(s) {
      return s.replace(/ァ/g, 'ア')
        .replace(/ィ/g, 'イ')
        .replace(/ゥ/g, 'ウ')
        .replace(/ェ/g, 'エ')
        .replace(/ォ/g, 'オ')
        .replace(/ッ/g, 'ツ')
        .replace(/ャ/g, 'ヤ')
        .replace(/ュ/g, 'ユ')
        .replace(/ョ/g, 'ヨ')
        .replace(/ヮ/g, 'ワ');
    }
  );

  return returnStr;
}

// 同義語処理(入力クエリに対して処理)
const charToSynonym = (str) => {
  let returnStr = str;
  const synonymList = JSON.parse(document.getElementById("synonymKeywords").textContent);

  // strが同義語リストに含まれている場合、同義語リストのキーを返す
  if(str.length > 0){
    for (const [key, value] of Object.entries(synonymList)) {
      if (value.split(",").find(valueItem => charToFuzzy(valueItem).includes(str))) {
        returnStr = key;
        break;
      }
    }
  }
  
  return returnStr;
}


// Add auto complete for search
const predictedKeywords = JSON.parse(document.getElementById("predictedKeywords").textContent);
const createAutoComplete = (_selector) => {
  const autoCompleteJS = new autoComplete({
    selector: _selector,
    placeHolder: "キーワードから探す",
    data: {
      src: predictedKeywords,
      cache: true,

      filter: (list) => {
        // 並べ替え処理
        //  1. 前方一致したワード
        //  2. 部分一致したワード
        const results = [];
        const resultsStartsWith = [];
        const resultsPartial = [];
        list.forEach((item) => {
          // const inputValue = autoCompleteJS.input.value.toLowerCase(); // 大文字小文字の区別なし
          // const itemValue = item.value.toLowerCase();
          const inputValue = charToFuzzy(autoCompleteJS.input.value);
          const itemValue =charToFuzzy(item.value);
          if (itemValue.startsWith(inputValue)) {
            resultsStartsWith.push(item);
          }else{
            resultsPartial.push(item);
          }
        });

        // resultsに、resultsStartsWithとresultsPartialの配列内容を結合して格納
        results.push(...resultsStartsWith);
        results.push(...resultsPartial);
    
        return results;
      },
    },
    resultItem: {
      highlight: false
    },
    submit: true,
    events: {
      input: {
        selection: (event) => {
          const selection = event.detail.selection.value;
          autoCompleteJS.input.value = selection;
          autoCompleteJS.input.click();
        },
        focus: (event) =>{
          // Open list on focus
          const inputValue = autoCompleteJS.input.value;
          autoCompleteJS.start();
        }
      }
    },
    // Show all items on click
    threshold: 0,
    resultsList: {
        maxResults: 10,
        destination: "#app-predictive-search-suggest-words",
        position: "beforeend",
        id: "autoComplete_Resultslist"
    },
    searchEngine: (query, record) => { 


      // 【Strict logic】
      // ひらがな・カタカナを区別なく予測表示
      // クエリ文字に対して同義語処理
      if(charToFuzzy(record).includes(charToSynonym(charToFuzzy(query)))){
        return record
      }
    }
  });
}
document.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("no-input-predictive-search");
  const intervalFindSearchBoxMobileId = setInterval(()=>{
    if(document.querySelector('#boost-pfs-search-box-mobile')){
      createAutoComplete("#boost-pfs-search-box-mobile");
      clearInterval(intervalFindSearchBoxMobileId);
      document.querySelector("#boost-pfs-search-box-mobile").addEventListener("selection", function (event) {
        // "event.detail" carries the autoComplete.js "feedback" object
        if(event.detail?.selection?.value){
          setTimeout(() => {
            document.querySelector('#boost-pfs-search-box-mobile').closest('form').submit();
          }, 100);
        }
      });
    }
  },1000);
  const intervalFindSearchBoxPcId = setInterval(()=>{
    if(document.querySelector('.predictive-search__input')){
      createAutoComplete(".predictive-search__input");
      clearInterval(intervalFindSearchBoxPcId);
      document.querySelector(".predictive-search__input").addEventListener("selection", function (event) {
        // "event.detail" carries the autoComplete.js "feedback" object
        if(event.detail?.selection?.value){
          setTimeout(() => {
            document.querySelector('.predictive-search__input').closest('form').submit();
          }, 100);
        }
      });
    }
  },1000);
});
// -----------------------------
// 2024.12.20 Add end :Header predictive search
// -----------------------------

// -----------------------------
// 2025.4.17 Add Start : Quick buy drawer loaded event
// -----------------------------
document.addEventListener("quick-buy-drawer:loaded", (event) => {
  const drawer = event.detail.drawer;
  // お気に入りアプリ対応
  if (typeof ReloadSmartWishlist !== "undefined" && typeof ReloadSmartWishlist === "function") {
    setTimeout(() => {
      ReloadSmartWishlist();
    }, 1000);
  }
});
// -----------------------------
// 2025.4.17 Add End : Quick buy drawer loaded event
// -----------------------------
